var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('canvas',{ref:"importances-chart",attrs:{"width":"160","height":"90"}})])}
var staticRenderFns = []

export { render, staticRenderFns }